/*
 * Module for the Seminars Index view
*/
rs.module("ui/content/events/seminars/index",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Unpack Js Selectors
            var filterSelect = $.js(jsSelectors.filterSelect);
            var seminars = $.js(jsSelectors.seminars);
            var skeleton = $.js(jsSelectors.skeleton);

            // Handle the filter select change event.
            filterSelect.change(function () {
                eventBanner.removeAllMessages();

                // Show skeleton while we load content.
                skeleton.show();
                seminars.hide();

                // Retrieve seminars
                $.get(
                    backendUrls.getSeminars,
                    {
                        upcoming: $(this).val()
                    })
                    .done(function (html) {
                        seminars.html(html);
                    })
                    .always(function () {
                        skeleton.hide();
                        seminars.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);